// frontend/src/components/DocumentViewerModal.js

import React, { useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import styles from './DocumentViewerModal.module.css';
import { useTranslation } from 'react-i18next';
import { api } from '../api';

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

const DocumentViewerModal = ({ isOpen, onClose, doc }) => {
  // Todos os hooks são chamados incondicionalmente no topo do componente.
  const { t } = useTranslation();
  const [numPages, setNumPages] = useState(null);
  const options = useMemo(() => ({
    cMapUrl: '/cmaps/',
    cMapPacked: true,
  }), []);

  // A lógica de retorno condicional agora vem DEPOIS dos hooks.
  if (!isOpen || !doc) {
    return null;
  }

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const filename = doc.storage_path.split('/').pop();
  const fileUrl = `${api.defaults.baseURL}/academic/documents/${filename}`;

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>{doc.original_filename.replace(/\.[^/.]+$/, "")}</h3>
          <button onClick={onClose} className={styles.closeButton}>×</button>
        </div>
        <div className={styles.modalBody}>
          <Document
            file={fileUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<p>{t('loadingDocument')}</p>}
            error={<p>{t('errorLoadingDocument')}</p>}
            options={options}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} className={styles.pdfPage} />
            ))}
          </Document>
        </div>
      </div>
    </div>,
    document.getElementById('root')
  );
};

export default DocumentViewerModal;